import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonLargeWeb } from "../../../../../components/ButtonLargeWeb";
import { NavigationButton } from "../../../../../components/NavigationButton";
import { StepperInglesLargo } from "../../../../../components/StepperInglesLargo";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

import "./style.css";

export const CorporativoBusinessBankingCheckoutWeb = () => {
  const colors = useDynamicColors();

  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-login-corporativo-web${currentParams}`);
  };

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-checkout">
            <div className="div-2">
              <div className="group-wrapper">
                <div className="div-wrapper-mail-code">
                  <div className="frame-wrapper">
                    <div className="frame-2">
                      <div className="review-container">
                        <h2 className="title-2">Review and confirm</h2>
                        <p className="subtitle">
                          Please review and confirm your company’s information
                          to proceed.
                        </p>

                        <div className="section-checkout">
                          <h3 className="section-checkout-title">
                            Business information
                          </h3>
                          <div className="row-step">
                            <div className="label">Nature of the business</div>
                            <div className="value">Software Development</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Category</div>
                            <div className="value">Technology Services</div>
                          </div>
                        </div>

                        <div className="section-checkout">
                          <h3 className="section-checkout-title">
                            Legal address
                          </h3>
                          <div className="row-step">
                            <div className="label">Address 1</div>
                            <div className="value">1234 Elm Street</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Address 2</div>
                            <div className="value">Suite 501</div>
                          </div>
                          <div className="row-step">
                            <div className="label">City</div>
                            <div className="value">San Francisco</div>
                          </div>
                          <div className="row-step">
                            <div className="label">State</div>
                            <div className="value">California</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Zip Code</div>
                            <div className="value">94107</div>
                          </div>
                        </div>

                        <div className="section-checkout">
                          <h3 className="section-checkout-title">
                            Company's main contact information
                          </h3>
                          <div className="row-step">
                            <div className="label">First and Last Name</div>
                            <div className="value">Ana Rodríguez</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Email</div>
                            <div className="value">ana@company.com</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Cell phone</div>
                            <div className="value">+1 (415) 555-0123</div>
                          </div>
                        </div>

                        <div className="section-checkout">
                          <h3 className="section-checkout-title">
                            Legal representatives
                          </h3>
                          <div className="row-step">
                            <div className="label">First and Last Name</div>
                            <div className="value">Carlos Méndez</div>
                          </div>
                          <div className="row-step">
                            <div className="label">ID Number</div>
                            <div className="value">A123456789</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Email</div>
                            <div className="value">carlos@company.com</div>
                          </div>
                          <div className="row-step">
                            <div className="label">Cell phone</div>
                            <div className="value">+1 (415) 555-6789</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-5" onClick={handleButtonClick}>
                        <ButtonLargeWeb
                          className="button-large-WEB-instance"
                          iconLeft={false}
                          iconRigth={false}
                          primarioActive
                          primarioInactive={false}
                          secundarioActive={false}
                          secundarioInactive={false}
                          terciarioActive={false}
                          terciarioInactive={false}
                          text="Confirm"
                          textClassName="button-large-WEB-2"
                        />
                      </div>

                      <div className="frame-6" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="component-7">
                {colors.url_logo !== "" && (
                  <img width={30} height="auto" src={colors.url_logo} />
                )}
                <div className="language">
                  <img
                    src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                    height={30}
                    width={30}
                  />
                </div>
              </div>

              <div className="group-4">
                <div className="frame-7">
                  © 2025 All rights reserved
                  <img width={100} height="auto" src="/img/veritran.svg" />
                  Innovation Lab
                </div>
              </div>

              <div className="frame-8">
                <div className="frame-9">
                  <NavigationButton
                    className="nav-button-left"
                    defaultMasterButtonNavDivClassName="navigation-button-instance"
                    focus={false}
                    platform="web-react"
                    state="default"
                    theme="light"
                    type="back"
                  />
                  <div className="text-wrapper-4">
                    Account opening application
                  </div>
                </div>

                <div className="group-5">
                  <div className="group-6">
                    <div className="group-7">
                      <div className="stepper-ingles-largo-wrapper">
                        <StepperInglesLargo
                          prendidoHasta={9}
                          className="stepper-ingles-largo-instance"
                          prendido="two"
                          property2="two"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
